export default "__VITE_ASSET__Dzc17B6s__";